import { createSlice } from '@reduxjs/toolkit';

interface AssessmentResult {
    program_name: string;
    scores: object;
    summary: object;
}

const initialState: AssessmentResult = {
    program_name: '',
    scores: {},
    summary: {},
};

export const assessmentSlice = createSlice({
    name: 'Assessment',
    initialState,
    reducers: {
        setAssessment: (state, action) => (state = action.payload),
    },
});

export const userSlice = createSlice({
    name: 'User',
    initialState,
    reducers: {
        setAssessment: (state, action) => (state = action.payload),
    },
});
